// extracted by mini-css-extract-plugin
module.exports = {"attrTable":"_2cmTEj_oXLvYx7xC-FejcG","priceQtyTable":"_2MFr7i0D2tdTxasa-_3Y1E","tierPriceTable":"_2s4s7c9AFiHoNaWxSm2KDq","textAttr":"_1iqetpTuyw9NOFdooXRjId"};